import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'

export default function ReviewSliders () {
  const CONTAINERS = document.querySelectorAll('.mtt-references--type-slider')
  if (CONTAINERS.length > 0) {
    for (let i = 0; i < CONTAINERS.length; i++) {
      const reviewSlider = new ReviewSlider(CONTAINERS[i])
      reviewSlider.init()
    }
  }
}

class ReviewSlider {
  constructor (CONTAINER) {
    this.CONTAINER = CONTAINER
    this.SWIPER_WRAPPER = this.CONTAINER.querySelector('.swiper')

    this.per_row = this.CONTAINER.getAttribute('data-per-row')
    this.autoplay = parseInt(this.CONTAINER.getAttribute('data-autoplay'))
  }

  init () {
    this.SWIPER_WRAPPER && this.createSwiper()
  }

  createSwiper () {
    const options = {
      modules: [Autoplay, Pagination],
      slidesPerView: 1,
      slidesPerGroup: 1,
      breakpoints: this.getBreakpoints(),
      speed: 800,
      spaceBetween: 24,
      freeMode: false,
      watchOverflow: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    }

    if (this.autoplay !== 0) {
      options.autoplay = { delay: this.autoplay }
    }

    this.SWIPER = new Swiper(this.SWIPER_WRAPPER, options)
  }

  getBreakpoints () {
    switch (parseInt(this.per_row)) {
      case 4:
        return {
          651: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          1051: {
            slidesPerView: 3,
            slidesPerGroup: 3
          },
          1451: {
            slidesPerView: 4,
            slidesPerGroup: 4
          }
        }
      case 3:
        return {
          651: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          1051: {
            slidesPerView: 3,
            slidesPerGroup: 3
          }
        }
      default:
        return {
          651: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
    }
  }
}